export default {
  loanList: {
    data: [],
    error: null,
    loading: false,
  },
  applyLoan: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
  checkLoan: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
  confirmLoan: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
  payLoan: {
    data: null,
    error: null,
    loading: false,
    success: false,
  },
};
